import { Component, Input } from '@angular/core';

@Component({
    selector: 'migration-banner',
    templateUrl: 'migration-banner.component.html',
    styleUrls: ['migration-banner.component.scss']
})
export class MigrationBannerComponent {
    @Input() shutdownDate: string;
}
